<template>
  <div v-if="accounts.length" class="overflow-auto">
    <vue-good-table
        :columns="[
      {
        label: $t('message.id'),
        field: 'id',
      },
      {
        label: $t('message.user'),
        field: 'fullName',
      },
      {
        label: $t('message.balance'),
        field: 'balance',
      },
      {
        label: $t('message.verification state'),
        field: 'verificationState',
      },

      {
        label: $t('message.registration time'),
        field: 'registrationTime',
      },
      {
        label: $t('message.last update'),
        field: 'lastUpdate',
      },
    ]"
        styleClass="vgt-table centered lesspadding2 striped custom-table"
        :rows="accounts"
        :pagination-options="{
          enabled: true,
          perPage: perpage,
          setCurrentPage: current,
        }"
        :search-options="{
          enabled: true,
          externalQuery: _searchTerm,
        }"
        @row-click="onRowClick"
    >
      <template v-slot:table-row="props">
        <span v-if="props.column.field === 'fullName'" class="flex items-center">
          <span class="text-sm text-slate-600 dark:text-slate-300 capitalize">
            {{ props.row.fullName }}
          </span>
        </span>
        <span v-if="props.column.field === 'lastUpdate'" class="block w-full">
          {{ convertTimestamp(props.row.lastUpdate) }}
        </span>
        <span v-if="props.column.field === 'registrationTime'" class="block w-full">
          {{ convertTimestamp(props.row.registrationTime) }}
        </span>
        <span v-if="props.column.field === 'action'">
              <div class="flex space-x-3 rtl:space-x-reverse">
                <Tooltip placement="top" arrow theme="dark">
                  <template #button>
                    <div class="action-btn">
                      <Icon icon="heroicons:eye"/>
                    </div>
                  </template>
                  <span> View</span>
                </Tooltip>
              </div>
            </span>
      </template>
      <template #pagination-bottom="props">
        <div class="py-4 px-3">
          <Pagination
              :total="accounts.length"
              :current="current"
              :per-page="perpage"
              :pageRange="pageRange"
              @page-changed="changePage"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
              enableSearch
              :options="options"
          >
          </Pagination>
        </div>
      </template>
    </vue-good-table>
  </div>
  <div v-else
       class="flex justify-center flex-wrap items-center flex-col text-center gap-10"
  >
    <img src="@/assets/images/all-img/no-data1.png" alt=""/>
    <!--    <h4 class="text-3xl font-medium text-slate-900 dark:text-white mb-2">
          NO DATA
        </h4>-->
    <p class="font-normal text-base text-slate-500 dark:text-slate-300 mb-2">
      {{ _emptyListMessage }}
    </p>
  </div>
</template>
<script>
import Dropdown from "@/components/Dropdown/index.vue";
import Card from "@/components/Card/index.vue";
import Icon from "@/components/Icon/index.vue";
import InputGroup from "@/components/InputGroup/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import {MenuItem} from "@headlessui/vue";
import {advancedTable} from "@/constant/basic-tablle-data";
import jalaliMoment from "jalali-moment";
import {useI18n} from "vue-i18n";
import Tooltip from "@/components/Tooltip/index.vue";
import {ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useManagementStore} from "@/stores/management.js";
import TableSkeleton from "@/components/Skeleton/Table.vue";

export default {
  components: {
    Pagination,
    InputGroup,
    Dropdown,
    Icon,
    Card,
    MenuItem,
    Tooltip,
    TableSkeleton
  },
  data() {
    return {
      advancedTable,
      actions: [
        {
          name: "view",
          icon: "heroicons-outline:eye",
        },
        {
          name: "edit",
          icon: "heroicons:pencil-square",
        },
        {
          name: "delete",
          icon: "heroicons-outline:trash",
        },
      ],
      options: [
        {
          value: "1",
          label: "1",
        },
        {
          value: "3",
          label: "3",
        },
        {
          value: "5",
          label: "5",
        },
      ],
    };
  },
  props: {
    accounts: {
      type: Array,
    },
    _title: {
      type: String,
    },
    _emptyListMessage: {
      type: String
    },
    _loading: {
      type: Boolean,
      default: false
    },
    _searchTerm: {
      type: String
    }
  },
  emits: [
    'openEmail'
  ],
  setup(props, {emit}) {
    const route = useRoute();
    const current = ref(Number(route.query.page) ? Number(route.query.page) : 1);
    const perpage = ref(10);
    const pageRange = ref(5);
    const {t, locale} = useI18n({useScope: 'global'})
    const router = useRouter();
    const managementStore = useManagementStore();

    function onRowClick(item) {
      managementStore.setSelectedApplicant(item.row)
      router.push({
        name: route.name,
        params: {orderID: route.params.orderID},
        query: {orderTitle: route.query.orderTitle, user: item.row.id}
      })
    }

    function convertTimestamp(timestamp) {
      const date = new Date(timestamp);
      const jalaliDate = jalaliMoment(date);
      if (locale.value === "fa") {
        return jalaliDate.locale('fa').format('jYYYY/jMM/jDD')
      } else {
        return date.toLocaleDateString();
      }
    }

    function changePage(e) {
      current.value = e;
      router.push({name: route.name, params: {orderID: route.params.orderID}, query: {page: e}})
    }

    return {
      onRowClick,
      convertTimestamp,
      changePage,
      current,
      perpage,
      pageRange,
      locale,
    }
  }
};
</script>
<style lang="scss">
.custom-table tbody tr:hover {
  background: none !important;
  background-color: rgba(177, 227, 217, 0.48) !important; /* Change the background color on hover */
  cursor: pointer; /* Change the cursor to indicate interactivity */
}
</style>
